import { render, staticRenderFns } from "./ModalDiscontinuedParticipant.vue?vue&type=template&id=0850b9db&scoped=true&"
import script from "./ModalDiscontinuedParticipant.vue?vue&type=script&lang=js&"
export * from "./ModalDiscontinuedParticipant.vue?vue&type=script&lang=js&"
import style0 from "./ModalDiscontinuedParticipant.vue?vue&type=style&index=0&id=0850b9db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0850b9db",
  null
  
)

export default component.exports